const RECOVERABLE_AUTH0_OAUTH_ERROR_SUBSTRINGS = [
  'invalid state',
  'invalid authorization code',
] as const;

export function isRecoverableAuth0OauthError(
  message: string | undefined,
): boolean {
  if (message == null || message === '') {
    return false;
  }
  const normalized = message.toLowerCase().trim();
  return RECOVERABLE_AUTH0_OAUTH_ERROR_SUBSTRINGS.some((fragment) =>
    normalized.includes(fragment),
  );
}
